// Helpers puros (sem hooks, sem JSX) compartilhados entre páginas
// Server e Client. Movidos pra cá pra que Server Components
// possam importar sem puxar o boundary "use client" de mbm-pages.jsx.

import { mapToPtPath } from "./route-map";
import { withLocale } from "./i18n";

export const ALL_FILTER = "__ALL__";

export function pickKind(type) {
  if (type === "shaft") return "shaft";
  if (type === "gear") return "gear";
  if (type === "rod") return "rod";
  return "stripes";
}

export function slugify(text) {
  return String(text ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
}

export function buildProductSlug(product) {
  const id = product?.id;
  if (id == null) return "";
  const slug = slugify(product?.name?.pt ?? "");
  return slug ? `${slug}-${id}` : String(id);
}

export function displayRef(ref) {
  const value = String(ref ?? "").trim();
  return /^#\d+$/.test(value) ? "" : value;
}

export function parseProductIdFromSlug(slug) {
  const raw = decodeURIComponent(String(slug ?? ""));
  const tail = raw.match(/(\d+)$/);
  if (!tail) return null;
  const n = Number(tail[1]);
  return Number.isFinite(n) ? n : null;
}

export function findSectionPayload(page, tipo) {
  const sections = page?.sections;
  if (!Array.isArray(sections)) return null;
  const found = sections.find((s) => s?.tipo === tipo);
  return found?.payload ?? null;
}

export function findSectionPayloadBy(page, predicate) {
  const sections = page?.sections;
  if (!Array.isArray(sections)) return null;
  let best = null;
  for (const s of sections) {
    if (!predicate(s)) continue;
    const payload = s?.payload ?? null;
    if (!payload) continue;
    if (payload.title) return payload;
    if (!best) best = payload;
  }
  return best;
}

export function parseAction(action, lang) {
  const label = String(action?.label ?? "");
  const primary = action?.primary === true;
  const raw = String(action?.href ?? "").trim();
  if (!raw) {
    return { label, primary, href: withLocale("/", lang), external: false, target: "/" };
  }
  if (/^https?:\/\//i.test(raw)) {
    return { label, primary, href: raw, external: true, target: raw };
  }
  const stripped = raw.replace(/^#/, "");
  const target = stripped.startsWith("/") ? stripped : `/${stripped}`;
  return {
    label,
    primary,
    href: withLocale(mapToPtPath(target), lang),
    external: false,
    target,
  };
}

export function parsePtBrNumber(str) {
  const cleaned = String(str ?? "").trim().replace(/\./g, "");
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
}

export function isAllCapsHeading(s) {
  if (!s || s.length > 100) return false;
  if (!/[A-ZÀ-Ý]/.test(s)) return false;
  return !/[a-zà-ý]/.test(s);
}
